export default __webpack_public_path__ + "static/fakegoogle_4-3739a1240403859e27d68991a410c6e1.jpg";